import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {testIdProps} from '@github-ui/test-id-props'
import type {ShowModelPayload} from '../../../types'
import {VerifiedHTMLBox} from '@github-ui/safe-html/VerifiedHTML'

export function License() {
  const {modelLicense} = useRoutePayload<ShowModelPayload>()

  return <VerifiedHTMLBox data-hpc className="p-3" html={modelLicense} {...testIdProps('license-content')} />
}
